import axios from 'axios'

const endpoints = {
  local: '/',
  develop: 'https://dev.vow.health',
  production: 'https://app.vow.health'
}

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
}

const instance = axios.create({
  baseURL: endpoints[process.env.MIX_APP_ENV],
  headers
})

export default instance
